import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'vb-loading-data',
  templateUrl: './loading-data.component.html',
  styleUrls: ['./loading-data.component.css']
})
export class LoadingDataComponent implements OnInit {

  @Input()
  loadingText: string = 'Lade Daten...';

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/loading/loading-data/loading-data.component.ts